import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DataProtectionConsentComponent } from './data-protection-consent/data-protection-consent.component';

import { DataProtectionModalComponent } from './data-protection-modal/data-protection-modal.component';

@NgModule({
  declarations: [
    DataProtectionConsentComponent,
    DataProtectionModalComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DataProtectionConsentComponent,
    DataProtectionModalComponent
  ]
})
export class DataProtectionModule {}